/**********************************************************************************************************************/
/* FILE: hafas_webapp_printview.js                                                                                          */
/**********************************************************************************************************************/
// contstructor for webapp printview, declare global Hafas-Variables
var HafasWebappPrintview = function (params) {

  var headerName = Hafas.Modules.i18n.get('common.print.t_N_Printview');
  document.title = headerName + ' - ' + Hafas.Config.client.name;

  // Atom-Modul anmelden
  Hafas.Core.newType("hafasAtoms", {
    Controller: this.Controller
  });

  // welche art der druckansicht?
  var printviewMode = 'tp';
  var printviewId = '';

  if (Hafas.Core.getParameterByName('mode') !== null) {
    printviewMode = Hafas.Core.getParameterByName('mode');
  }

  if (Hafas.Core.getParameterByName('id') !== null) {
    printviewId = Hafas.Core.getParameterByName('id');
  }

  Hafas('html').addClassName('lyr_PRINT_' + printviewMode);

  // nur erlaubte werte durchgeben

  // einfache tp druckansicht
  // ========================
  if (printviewMode === 'tp') {
    // objekt im session storage vorhanden?
    if (sessionStorage.getItem('print_tp_' + printviewId)) {

      var dataObject = JSON.parse(sessionStorage.getItem('print_tp_' + printviewId));

      Hafas.Modules.Loader.loadTemplateFiles(['common.html','common.newmessages.html','common.new.html', 'common.icons.html', 'common.product.html'], function() {
      Hafas.Modules.Render.render({
        file: 'tp.print_detail.html',
        target: 'HFS_PRINT',
        template: 'TP_TplPrintDetail',
        model: dataObject.connection
      }, function () {
        window.print();
      });
      });
    }
    else {
      printError();
    }
  }

  // sq druckansicht
  // ===============
  else if (printviewMode === 'sq') {

    // objekt im session storage vorhanden?
    if (sessionStorage.getItem('print_sq_' + printviewId)) {

      var dataObject = JSON.parse(sessionStorage.getItem('print_sq_' + printviewId));
      //console.log(dataObject);

      Hafas.Modules.Loader.loadTemplateFiles(['common.newmessages.html','sq.result.html'], function(){
        Hafas.Modules.Render.render({
          file: 'sq.result.print.html',
          target: 'HFS_PRINT',
          template: 'SQ_TplPrint',
          model: dataObject.resolvedData
        }, function () {
          window.print();
        });

      });

    }
    else {
      printError();
    }

  }

  else if (printviewMode == 'timetable') {
    // objekt im session storage vorhanden?
    if (sessionStorage.getItem('print_timetable_' + printviewId)) {

      var dataObject = JSON.parse(sessionStorage.getItem('print_timetable_' + printviewId));

      Hafas.Modules.Loader.loadTemplateFiles(['common.html', 'common.icons.html', 'common.product.html', 'timetable.result.html', 'common.buttons.html', 'common.new.html', 'common.content.html'], function(){
        Hafas.Modules.Render.render({
          file: 'timetable.print.html',
          target: 'HFS_PRINT',
          template: 'Timetable_TplPrint',
          model: dataObject.result
        }, function () {});
      });
    }
    else {
      printError();
    }
  }

  function printError() {
    alert(Hafas.Modules.i18n.get('Print.t_N_ErrorWhileInitializing'));
    window.close();
  }
};
